import { render, staticRenderFns } from "./WayPointsTable.vue?vue&type=template&id=8e5b80b6&scoped=true&"
import script from "./WayPointsTable.vue?vue&type=script&lang=js&"
export * from "./WayPointsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5b80b6",
  null
  
)

export default component.exports